import { push, ref, serverTimestamp, update } from "firebase/database";
import { signInAnonymously } from "firebase/auth";
import { auth, rtdb } from "../firebase";

// The contact form (components/ContactForm.js) is how visitors reach us: each
// message is saved to contact/{id}, which only the site owner can read, on
// the moderation page. The database rules allow one message a minute per
// player (contactSent/{uid}) and check every field.
export const CONTACT_TOPICS = ["question", "report", "privacy", "legal"];
export const MESSAGE_MAX = 3000;

export async function sendContact({ topic, message, email, name, room, reported, lang }) {
  // Visitors who haven't played yet get a guest login, like when they join a room.
  if (!auth.currentUser) await signInAnonymously(auth);
  const uid = auth.currentUser.uid;
  const id = push(ref(rtdb, "contact")).key;
  const msg = {
    uid,
    topic: CONTACT_TOPICS.includes(topic) ? topic : "question",
    message: message.trim().slice(0, MESSAGE_MAX),
    page: window.location.pathname.slice(0, 200),
    lang: String(lang || "en").slice(0, 5),
    at: serverTimestamp(),
  };
  if (email?.trim()) msg.email = email.trim().slice(0, 120);
  if (name?.trim()) msg.name = name.trim().slice(0, 40);
  if (room) msg.room = room;
  // A report about a player, from the 👥 list in a room.
  if (reported?.id) msg.reported = { uid: reported.id, name: String(reported.name || "?").slice(0, 40) };
  return update(ref(rtdb), { [`contact/${id}`]: msg, [`contactSent/${uid}`]: serverTimestamp() });
}
